import AdminNavBar from "./AdminNavBar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link, navigate, useNavigate } from "react-router-dom";
import {
  Card,
  Col,
  Container,
  Dropdown,
  Nav,
  Modal,
  Row,
  Table,
} from "react-bootstrap";
import logo1 from "../Assets/logonew.png";
import logo2 from "../Assets/userlogo.svg";
import React, { useState, useEffect } from "react";
import "./Master.css";
import "../Admin/AdminMaster/AdminBilling.css";
import { Table as AntTable, Tag } from "antd";
import axios from "axios";
import {
  AdminDashboardAPI,
  AdminDashboardCountAPI,
  DeliverPendingDailyListApi,
  PieChartTotal,
} from "../Admin/API/Api";
import { Popover, Typography } from "@mui/material";
import { FaUserCircle } from "react-icons/fa";
import { AiOutlineLogout } from "react-icons/ai";
import { RiLockPasswordFill } from "react-icons/ri";
import NavLogo from "./NavLogo";
import { PieChart } from "@mui/x-charts/PieChart";
import { MDBDataTable } from "mdbreact";

const AdminDashboard1 = () => {
  const [columns, setColumns] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [dashboardData, setDashboardData] = useState(null);
  const userdata = JSON.parse(sessionStorage.getItem("userdata"));
  const branchId = userdata.branch_id;
  const Name = userdata ? userdata.branch_name : "";
  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const selectedLanguage = sessionStorage.getItem("selectedLanguage");

  const [dailyStocklist, setdailyStocklist] = useState([]);
  const [ProductDeliverylist, setProductDeliverylist] = useState([]);
  const [pendingBagList, setPendingBagList] = useState([]);

  const handleCardClick = () => {
    setShowModal(true);
    fetchdailyStocklist(); // Assuming fetchdailyStocklist is a function to fetch data
  };

  const handleCardClick1 = () => {
    setShowModal1(true);
    fetchProductdeliverylist(); // Assuming fetchProductdeliverylist is a function to fetch data
  };

  const handleCardClick2 = () => {
    setShowModal2(true);
    fetchPendingBagList(); // Assuming fetchPendingBagList is a function to fetch data
  };

  let isDashboardFetched = false
  useEffect(() => {
    if (isDashboardFetched) return
    fetchData();
    fetchData1();
    isDashboardFetched = true
  }, []);

  // const fetchData = async () => {
  //   try {
  //     const obj = {
  //       branch_id: branchId,
  //     };

  //     const response = await axios.post(AdminDashboardAPI, obj);
     
  //     const list = response.data || [];
  //     const firstObject = list[0] || {};
  //     const cols = [];
  //     for (const key in firstObject) {
  //       var render = (value) => {
  //         return <span>{String(value)}</span>;
  //       };
  //       if (typeof firstObject[key] === "object") {
  //         if (Array.isArray(firstObject[key])) {
  //           render = (value) => {
  //             return (
  //               <span>
  //                 {value.map((tag) => {
  //                   return <Tag key={tag}>{tag}</Tag>;
  //                 })}
  //               </span>
  //             );
  //           };
  //         } else {
  //           render = (value) => {
  //             return (
  //               <span>
  //                 {Object.keys(value).map((innerKey) => {
  //                   return (
  //                     <div key={innerKey}>
  //                       {innerKey} : {value[innerKey]}
  //                     </div>
  //                   );
  //                 })}
  //               </span>
  //             );
  //           };
  //         }
  //       }

  //       const col = {
  //         title: String(key).charAt(0).toUpperCase() + String(key).slice(1),
  //         dataIndex: key,
  //         render: render,
  //       };
  //       cols.push(col);
  //     }

  //     // Calculate totals for each column
  //     const totals = {};
  //     list.forEach((item) => {
  //       for (const key in item) {
  //         if (key !== "EmployeeName") {
  //           totals[key] = (totals[key] || 0) + parseInt(item[key]);
  //         }
  //       }
  //     });

  //     // Add totals to the last row
  //     const totalRow = { ...totals, EmployeeName: "Total" };
  //     list.push(totalRow);

  //     // Add the total column
  //     const totalCol = {
  //       title: "Total",
  //       dataIndex: "total",
  //       render: (value) => <span>{value}</span>,
  //     };
  //     cols.push(totalCol);

  //     setColumns(cols);

  //     // Calculate totals for each row and add the total value as a property to each row object
  //     const updatedList = list.map((item) => {
  //       let total = 0;
  //       for (const key in item) {
  //         if (key !== "EmployeeName") {
  //           total += parseInt(item[key]);
  //         }
  //       }
  //       return { ...item, total };
  //     });

  //     // Update dataSource state
  //     setDataSource(updatedList);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     // Handle errors
  //   }
  // };


  const fetchData = async () => {
    try {
      const obj = {
        branch_id: branchId,
      };
  
      // Fetch data from API
      const response = await axios.post(AdminDashboardAPI, obj);
  
      const list = response.data || [];
      const firstObject = list[0] || {};
      const cols = [];
  
      // Dynamically create columns
      for (const key in firstObject) {
        let render = (value) => {
          return <span>{String(value)}</span>;
        };
  
        // Handle array and object types
        if (typeof firstObject[key] === "object") {
          if (Array.isArray(firstObject[key])) {
            render = (value) => (
              <span>
                {value.map((tag, index) => (
                  <Tag key={index}>{tag}</Tag>
                ))}
              </span>
            );
          } else {
            render = (value) => (
              <span>
                {Object.keys(value).map((innerKey) => (
                  <div key={innerKey}>
                    {innerKey} : {value[innerKey]}
                  </div>
                ))}
              </span>
            );
          }
        }
  
        const col = {
          title: String(key).charAt(0).toUpperCase() + String(key).slice(1),
          dataIndex: key,
          render: render,
        };
  
        cols.push(col);
      }
  
      // Calculate totals for each column
      const totals = {};
      list.forEach((item) => {
        for (const key in item) {
          if (key !== "EmployeeName") {
            totals[key] = (totals[key] || 0) + parseInt(item[key]);
          }
        }
      });
  
      // Add totals row
      const totalRow = { ...totals, EmployeeName: "Total" };
      list.push(totalRow);
  
      // Add a new column for totals
      const totalCol = {
        title: "Total",
        dataIndex: "total",
        render: (value) => <span>{value}</span>,
      };
      cols.push(totalCol);
  
      // Update state for columns
      setColumns(cols);
  
      // Calculate totals for each row
      const updatedList = list.map((item) => {
        let total = 0;
        for (const key in item) {
          if (key !== "EmployeeName") {
            total += parseInt(item[key]);
          }
        }
        return { ...item, total };
      });
  
      // Update dataSource state with calculated totals
      setDataSource(updatedList);
  
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle errors
    }
  };
  

  // ============== count API =====================

  
  const fetchData1 = async () => {
    try {
      const response = await axios.post(AdminDashboardCountAPI, {
        branch_id: branchId,
      });

      const data = response.data;
      setDashboardData(data);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };


  // Product Delivery Count-----------------------------
  const fetchdailyStocklist = async () => {
    try {
      const response = await axios.post(DeliverPendingDailyListApi, {
        branch_id: branchId,
      });
      console.log("api console pending Baglist.....", response.data);
      setdailyStocklist(response.data.dailystocklist || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Product Delivery Count-----------------------------
  const fetchProductdeliverylist = async () => {
    try {
      const response = await axios.post(DeliverPendingDailyListApi, {
        branch_id: branchId,
      });
      console.log("api console pending Baglist.....", response.data);
      setProductDeliverylist(response.data.Productdeliverylist || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Product Pending Count --------------------------------
  const fetchPendingBagList = async () => {
    try {
      const response = await axios.post(DeliverPendingDailyListApi, {
        branch_id: branchId,
      });
      console.log("api console pending Baglist.....", response.data);
      setPendingBagList(response.data.pendingbaglist || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // ========================Piechart ======================
  const [presentCount, setPresentCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);

  let isDashboard1Fetched = false
  useEffect(() => {
    if (isDashboard1Fetched) return
    // Make API call to retrieve data
    axios
      .post(PieChartTotal, {
        branch_id: branchId,
      })
      .then((response) => {
        // Process response and update counts
        const { Feb, Mar, Apr } = response.data;
        // setPresentCount(
        //   (Feb.present ? Feb.present.count : 0) +
        //     (Mar.present ? Mar.present.count : 0) +
        //     (Apr.present ? Apr.present.count : 0)
        // );
        // setPendingCount(
        //   (Feb.pending ? Feb.pending.count : 0) +
        //     (Mar.pending ? Mar.pending.count : 0) +
        //     (Apr.pending ? Apr.pending.count : 0)
        // );
         // Sum present and pending counts across months
      setPresentCount(
        (Feb?.present ? Feb.present.count : 0) +
        (Mar?.present ? Mar.present.count : 0) +
        (Apr?.present ? Apr.present.count : 0)
      );

      setPendingCount(
        (Feb?.pending ? Feb.pending.count : 0) +
        (Mar?.pending ? Mar.pending.count : 0) +
        (Apr?.pending ? Apr.pending.count : 0)
      );
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
      isDashboard1Fetched = true
  }, []);

  return (
    <Container fluid>
      <AdminNavBar />
      <section className="home-section">
        <NavLogo />

        <Row className="m-0 p-0 pt-5 px-md-4 px-2">
          <Col
            className=" rounded text-center pt-2"
            style={{
              display: "flex",
              justifyContent: "start",
              backgroundColor: "white",
              border: "0px",
              alignItems: "center",
              alignContent: "center",
              color: " rgb(47, 79, 79)",
            }}
          >
            <h5>{selectedLanguage === "Marathi" ? "डॅशबोर्ड" : "DASHBOARD"}</h5>
          </Col>
        </Row>

        <Row>
          <PieChart
            colors={["tomato", "MediumSeaGreen"]}
            series={[
              {
                data: [
                  {
                    id: 0,
                    value: pendingCount,
                    label:
                      selectedLanguage === "Marathi"
                        ? "प्रलंबित बिल"
                        : "Pending Bill",
                  },
                  {
                    id: 1,
                    value: presentCount,
                    label:
                      selectedLanguage === "Marathi"
                        ? "बिल तयार केलेले"
                        : "Generated Bill",
                  },
                ],
              },
            ]}
            width={400}
            height={200}
          />
        </Row>

        <Row className="m-0 p-0 ">
          <Row md={5} xs={1} className="g-4 m-0 p-0 px-md-3">
            <Col className=" px-2 rounded text-center pt-1">
              <Card className="DashHover" style={{ border: "0px" }}>
                <Card.Body className="text-center">
                  <Card.Text>
                    <h5 style={{ color: "rgb(47, 79, 79)" }}>
                      {dashboardData && dashboardData.paymentpendingamount}
                    </h5>
                  </Card.Text>
                  <p>
                    {selectedLanguage === "Marathi"
                      ? "पेमेंट प्रलंबित रक्कम"
                      : "Payment Pending Amount"}
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col className="px-2  rounded text-center pt-1">
              <Card className="DashHover" style={{ border: "0px" }}>
                <Card.Body className="text-center">
                  <Card.Text>
                    <h5 style={{ color: "rgb(47, 79, 79)" }}>
                      {dashboardData && dashboardData.todaystotalpaymentamount}
                    </h5>
                  </Card.Text>
                  <p>
                    {selectedLanguage === "Marathi"
                      ? "आज रक्कम मिळाली"
                      : "Today Received Amount"}
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col className="px-2 rounded text-center pt-1">
              <Card
                className="DashHover"
                style={{ border: "0px" }}
                onClick={handleCardClick}
              >
                <Card.Body className="text-center">
                  <Card.Text>
                    <h5 style={{ color: "rgb(47, 79, 79)" }}>
                      {dashboardData && dashboardData.dailystockcount}
                    </h5>
                  </Card.Text>
                  <p>
                    {selectedLanguage === "Marathi"
                      ? "दैनिक स्टॉक संख्या"
                      : "Daily Stock Count"}
                  </p>
                </Card.Body>
              </Card>
              <Modal
                size="lg"
                show={showModal}
                onHide={() => setShowModal(false)}
              >
                <Modal.Header
                  style={{ backgroundColor: "rgb(135, 178, 178)" }}
                  closeButton
                >
                  <Modal.Title>
                    {selectedLanguage === "Marathi"
                      ? "दैनिक स्टॉक संख्या"
                      : "Daily Stock Count"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <MDBDataTable
                    striped
                    bordered
                    hover
                    className="custom-datatable"
                    data={{
                      columns: [
                        {
                          label:
                            selectedLanguage === "Marathi"
                              ? "कर्मचारी नाव"
                              : "Employee Name",
                          field: "EmployeeName",
                          sort: "asc", // or 'desc' for descending sorting order
                        },
                        {
                          label:
                            selectedLanguage === "Marathi"
                              ? "उत्पादनाचे नांव"
                              : "Product Name",
                          field: "product_name",
                          sort: "asc",
                        },
                        {
                          label:
                            selectedLanguage === "Marathi"
                              ? "दैनिक प्रमाण"
                              : "Daily Quantity",
                          field: "quantity",
                          sort: "asc",
                        },
                      ],
                      rows: dailyStocklist.map((item, index) => ({
                        EmployeeName: item.EmployeeName,
                        product_name: item.product_name,
                        quantity: item.quantity,
                      })),
                    }}
                  />
                </Modal.Body>
              </Modal>
            </Col>

            <Col className="px-2 rounded text-center pt-1">
              <Card
                className="DashHover"
                style={{ border: "0px" }}
                onClick={handleCardClick1}
              >
                <Card.Body className="text-center">
                  <Card.Text>
                    <h5 style={{ color: "rgb(47, 79, 79)" }}>
                      {dashboardData && dashboardData.Productdeliverycount}
                    </h5>
                  </Card.Text>
                  <p>
                    {selectedLanguage === "Marathi"
                      ? "उत्पादन वितरण संख्या"
                      : "Product Delivery Count"}
                  </p>
                </Card.Body>
              </Card>
              <Modal
                size="lg"
                show={showModal1}
                onHide={() => setShowModal1(false)}
              >
                <Modal.Header
                  style={{ backgroundColor: "rgb(135, 178, 178)" }}
                  closeButton
                >
                  <Modal.Title>
                    {selectedLanguage === "Marathi"
                      ? "उत्पादन वितरण संख्या"
                      : "Product Delivery Count"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <MDBDataTable
                    striped
                    bordered
                    hover
                    className="custom-datatable"
                    data={{
                      columns: [
                        {
                          label:
                            selectedLanguage === "Marathi"
                              ? "कर्मचारी नाव"
                              : "Employee Name",
                          field: "EmployeeName",
                          sort: "asc",
                        },
                        {
                          label:
                            selectedLanguage === "Marathi"
                              ? "उत्पादनाचे नांव"
                              : "Product Name",
                          field: "product_name",
                          sort: "asc",
                        },
                        {
                          label:
                            selectedLanguage === "Marathi"
                              ? "वितरण प्रमाण"
                              : "Delivery Quantity",
                          field: "quantity",
                          sort: "asc",
                        },
                      ],
                      rows: ProductDeliverylist.map((item, index) => ({
                        EmployeeName: item.EmployeeName,
                        product_name: item.product_name,
                        quantity: item.quantity,
                      })),
                    }}
                  />
                </Modal.Body>
              </Modal>
            </Col>

            <Col className="px-2 rounded text-center pt-1">
              <Card
                className="DashHover"
                style={{ border: "0px" }}
                onClick={handleCardClick2}
              >
                <Card.Body className="text-center">
                  <Card.Text>
                    <h5 style={{ color: "rgb(47, 79, 79)" }}>
                      {dashboardData && dashboardData.pendingbag}
                    </h5>
                  </Card.Text>
                  <p>
                    {selectedLanguage === "Marathi"
                      ? "उत्पादन प्रलंबित संख्या"
                      : "Product Pending Count"}
                  </p>
                </Card.Body>
              </Card>
              <Modal
                size="lg"
                show={showModal2}
                onHide={() => setShowModal2(false)}
              >
                <Modal.Header
                  style={{ backgroundColor: "rgb(135, 178, 178)" }}
                  closeButton
                >
                  <Modal.Title>
                    {selectedLanguage === "Marathi"
                      ? "उत्पादन प्रलंबित संख्या"
                      : "Product Pending Count"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <MDBDataTable
                    striped
                    bordered
                    hover
                    className="custom-datatable"
                    data={{
                      columns: [
                        {
                          label:
                            selectedLanguage === "Marathi"
                              ? "कर्मचारी नाव"
                              : "Employee",
                          field: "EmployeeName",
                          sort: "asc",
                        },
                        {
                          label:
                            selectedLanguage === "Marathi"
                              ? "उत्पादनाचे नांव"
                              : "Product Name",
                          field: "product_name",
                          sort: "asc",
                        },
                        {
                          label:
                            selectedLanguage === "Marathi"
                              ? "प्रलंबित प्रमाण"
                              : "Pending Quantity",
                          field: "pending_quantity",
                          sort: "asc",
                        },
                      ],
                      rows: pendingBagList.map((item, index) => ({
                        EmployeeName: item.EmployeeName,
                        product_name: item.product_name,
                        pending_quantity: item.pending_quantity,
                      })),
                    }}
                  />
                </Modal.Body>
              </Modal>
            </Col>
          </Row>
        </Row>

        <Row className="p-0 m-0 px-md-3 ">
          <div style={{ overflowY: "auto" }}>
            <div style={{ overflowX: "auto" }}>
              <div
                className="mt-4 ant-table-wrapper"
                style={{
                  marginBottom: "80px",
                  maxHeight: "800px",
                  border: "0px",
                  borderRadius: "10px",
                }}
              >
                <AntTable
                  className="custom-table"
                  columns={columns}
                  dataSource={dataSource}
                  pagination={{ position: ["bottomCenter"] }}
                />
              </div>
            </div>
          </div>
        </Row>
      </section>
    </Container>
  );
};

export default AdminDashboard1;
